import { render, staticRenderFns } from "./modal-description.component.vue?vue&type=template&id=64aa8e38&scoped=true&"
import script from "./modal-description.component.vue?vue&type=script&lang=ts&"
export * from "./modal-description.component.vue?vue&type=script&lang=ts&"
import style0 from "./modal-description.component.vue?vue&type=style&index=0&id=64aa8e38&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aa8e38",
  null
  
)

export default component.exports